import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import {Items} from '../models/items';
import {HeaderData} from '../models/header-data';

import {DataService} from './data.service';

@Injectable()
export class HeaderDataService {

    constructor(private data: DataService) {
    }

    public errorProc(error: HttpErrorResponse, errorHandler?: (error: HttpErrorResponse) => void) {
        // this.utilsService.debugLog(error);
        if (error && error.status == 401) {
            let loginUrl: string = error.error.login_url;
            let returnURL = encodeURIComponent(document.location.href);
            window.location.href = loginUrl + '&goto=' + returnURL;
        } else if (errorHandler) {
            errorHandler(error);
        }
    }

    getMenuItems(menuEndpoint: string): Observable<any> {
        //return this.http.get(menuEndpoint, {withCredentials: true})
        return this.data.get(menuEndpoint)
            .map(data => this.extractMenuData(data));
    }

    private extractMenuData(data: any) {
        let body = data;
        body = body.data;

        let menuAppArray: Items[] = [];
        let menuBtnHeader: Items[] = [];
        let menuUserArray: Items[] = [];
        let childrenMenuUserArray: Items[] = [];

        if (body.app_menu !== undefined) {
            for (let i = 0; i < body.app_menu.length; i++) {
                let items = body.app_menu[i];
                let newAppMenu: Items = {
                    item_id: items.item_id,
                    label: items.label,
                    type: items.type,
                    reference: items.reference,
                    referenceType: items.reference_type,
                    permission: items.permission,
                    resource: items.resource,
                    children: items.children
                };
                menuAppArray.push(newAppMenu);
            }
        }

        if (body.header_btn_menu !== undefined) {
            for (let i = 0; i < body.header_btn_menu.length; i++) {
                let items = body.header_btn_menu[i];
                let newBtnHeader: Items = {
                    item_id: items.item_id,
                    label: items.label,
                    type: items.type,
                    reference: items.reference,
                    referenceType: items.reference_type,
                    permission: items.permission,
                    resource: items.resource,
                    children: items.children
                };
                //this.utilsService.debugLog(newBtnHeader);
                menuBtnHeader.push(newBtnHeader);
            }
        }

        if (body.user_menu !== undefined) {
            for (let i = 0; i < body.user_menu.length; i++) {
                let items = body.user_menu[i];

                let childrenItems = body.user_menu[i].children;
                //this.utilsService.debugLog(childrenItems);
                for (let x = 0; x < body.user_menu[i].children.length; x++) {
                    let newChildrenItem: Items = {
                        item_id: childrenItems[x].item_id,
                        label: childrenItems[x].label,
                        type: childrenItems[x].type,
                        reference: childrenItems[x].reference,
                        referenceType: childrenItems[x].reference_type,
                        permission: childrenItems[x].permission,
                        resource: childrenItems[x].resource,
                        children: childrenItems[x].children
                    };
                    childrenMenuUserArray.push(newChildrenItem);
                }

                let newUserMenu: Items = {
                    item_id: items.item_id,
                    label: items.label,
                    type: items.type,
                    reference: items.reference,
                    referenceType: items.reference_type,
                    permission: items.permission,
                    resource: items.resource,
                    children: childrenMenuUserArray
                };
                menuUserArray.push(newUserMenu);
            }
        }

        let newHeaderData: HeaderData = {
            headerBtnMenu: menuBtnHeader,
            userMenu: menuUserArray,
            appMenu: menuAppArray,
            userMenuLabel: body.user_menu_label
        };

        return newHeaderData || {};
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/header-data.service.ts